import { Box, FormControl, Grid, MenuItem, Select } from '@mui/material';
import { IReportField } from '../../types/reportField';

const DropdownFilterField = ({ reportField, onChange }: { reportField: IReportField; onChange }) => (
  <Grid size={{ xs: 12 }}>
    <FormControl sx={{ mb: 3, width: '100%' }}>
      <Box sx={{ mb: 1 }}>
        <label>{reportField?.caption}:</label>
      </Box>
      <Select onChange={onChange} size="small" defaultValue={reportField?.items[0].value}>
        {[<MenuItem key={-1}></MenuItem>].concat(
          reportField?.items.map((c, i) => (
            <MenuItem key={i} value={c && c.value.toString()}>
              {c.text}
            </MenuItem>
          ))
        )}
        ;
      </Select>
    </FormControl>
  </Grid>
);

export default DropdownFilterField;
